import React from 'react'
import { Link } from 'react-router-dom'

function FooterOne() {
  return (
    <footer className="main-footer inner wow fadeInUp">
      <div className="upper-section section-kt">
        <div className="auto-container">
          <div className="row clearfix">
            {/* Footer Col */}
            <div className="footer-col info-col col-lg-6 col-md-12 col-sm-12">
              <div
                className="inner wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div className="content">
                  <div className="logo">
                    <a href="index" title="Tickling Tummy">
                      <img
                        src="assets/images/tickling-tummy-logo-coimbatore.svg"
                        alt="Tickling Tummy"
                        title="Tickling Tummy"
                      />
                    </a>
                  </div>
                  <div className="info">
                    <h6>Address </h6>
                    <ul>
                      <li>103, West Periasamy Rd, Vincent Colony,</li>
                      <li>R.S. Puram, Coimbatore, Tamil Nadu 641002</li>
                      <li>
                        <a href="tel:+91-9385000111">
                          Booking Request : +91-9385000111
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Image Col */}
            <div className="footer-col footer-image-col col-lg-3 col-md-6 col-sm-12">
              <div className="footer-image">
                <img src="assets/images/tasty-homemade-food-footer-display.jpg" alt="image" />
              </div>
            </div>

            <div className="footer-col footer-image-col last col-lg-3 col-md-6 col-sm-12">
              <div className="footer-image">
                <img src="assets/images/fresh-veg-meals-footer-display.jpg" alt="image" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* last footer */}
      <div className="bottom_footer">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-4 col-md-4 col-sm-12">
              <p>© 2025 All Rights Reserved</p>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12">
              <ul className="social_media">
                <li>
                  <a
                    href="https://www.facebook.com/share/16rD3zZNRy/"
                    aria-label="facebook page"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.instagram.com/tickling.tummy"
                    aria-label="instagram page"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12">
              <p className="developer_text">
                Crafted by{" "}
                <a href="https://www.pooglemedia.com/" target="_blank" rel="noreferrer">
                  Poogle
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>

  )
}

export default FooterOne
